import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/legacy/index.css";
import "./styles/legacy/media_queries.css";
import "./styles/v2/main.css";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./store";
import { RouterProvider } from "react-router-dom";
import { app_router } from "./utils/routes/app_routes";
import { cleanupLegacyServiceWorkers } from "./utils/pwa/serviceWorkerCleanup";
import { installWebAppUpdateChecker } from "./utils/appUpdate/webAppUpdateChecker";

const root = ReactDOM.createRoot(document.getElementById("root"));
/*
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
*/
const router = app_router;
root.render(
  <Provider store={store}>
    <RouterProvider router={router} />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

cleanupLegacyServiceWorkers();

// No-op outside the Plaintr mobile wrapper.
installWebAppUpdateChecker();
